import React from "react";
import "../App.css";

function Footer() {
  return (
    <div>
      <section class="footer">
        <div class="footer-text">
          <p>© 2022-2023 Pacifica Pizza {""} Developed by: Jonathan Plaisted</p>
        </div>
      </section>
    </div>
  );
}

export default Footer;
